import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, UntypedFormGroup, UntypedFormBuilder, UntypedFormArray } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { MatTableModule } from '@angular/material/table';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatRadioModule } from '@angular/material/radio';

@Component({
    selector: 'app-injured-details',
    templateUrl: './injured-details.component.html',
    styleUrls: ['./injured-details.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        MatCheckboxModule,
        MatButtonModule,
        MatTableModule,
        MatExpansionModule,
        MatIconModule,
        MatRadioModule
    ]
})
export class InjuredDetailsComponent implements OnInit {
  form: UntypedFormGroup;
  displayedColumns: string[] = ['name', 'address', 'contactNumber', 'type', 'description'];
  dataSource = [];

  constructor(private fb: UntypedFormBuilder, private readonly cdr: ChangeDetectorRef) {}
  ngOnInit() {
    this.form = this.fb.group({
      injuredPersons: this.fb.array([]),
    });
    this.addRow(); // Add initial row

    this.dataSource = [...this.injuredPersons.controls];
  }

  get injuredPersons() {
    return this.form.get('injuredPersons') as UntypedFormArray;
  }

  addRow() {
    const personForm = this.fb.group({
      name: [''],
      address: [''],
      contactNumber: [''],
      type: [''],
      description: [''],
    });
    this.injuredPersons.push(personForm);
    this.dataSource = [...this.injuredPersons.controls];
    this.cdr.detectChanges();
  }


  removeRow(index: number) {
    this.injuredPersons.removeAt(index);
    this.updateDataSource();
  }

  private updateDataSource() {
    this.dataSource = [...this.injuredPersons.controls];
    this.cdr.detectChanges();
  }

}
